import { actionTypes } from 'actions/actionTypes'
import {
  addCuratedBox,
  curatedBoxLoseRecipesWarning,
  dismissCuratedBoxModal,
} from 'actions/trackingKeys'

export const trackAddCuratedBox = (
  numPortions: number,
  curatedBoxName: string,
  carouselIndex: number,
  curatedBoxRecipes: string[],
  curatedBoxCollectionId: string,
  menuId: string,
  hasSeenModal: boolean,
  basketRecipesCount: number,
) => ({
  type: actionTypes.TRACKING,
  trackingData: {
    actionType: addCuratedBox,
    warningGiven: hasSeenModal ? 1 : 0,
    addType: 'curated',
    boxSize: numPortions,
    curatedBoxCategory: curatedBoxName,
    carouselPosition: carouselIndex,
    recipeIds: curatedBoxRecipes,
    collection: curatedBoxCollectionId,
    currentMenuId: menuId,
    recipesAlreadyInBasket: basketRecipesCount,
  },
})

export const trackCuratedBoxLoseRecipesWarning = (
  numPortions: number,
  curatedBoxName: string,
  carouselIndex: number,
  curatedBoxRecipes: string[],
  curatedBoxCollectionId: string,
  menuId: string,
) => ({
  type: actionTypes.TRACKING,
  trackingData: {
    actionType: curatedBoxLoseRecipesWarning,
    recipeIds: curatedBoxRecipes,
    curatedBoxCategory: curatedBoxName,
    collection: curatedBoxCollectionId,
    carouselPosition: carouselIndex,
    currentMenuId: menuId,
    boxSize: numPortions,
  },
})

export const trackDismissCuratedBoxLoseRecipesModal = (elementClicked: string) => ({
  type: actionTypes.TRACKING,
  trackingData: {
    actionType: dismissCuratedBoxModal,
    dismiss_ui: elementClicked === 'button' ? 'button' : 'cross',
  },
})
